import type { FormFieldProps } from '@pesto/ui/features/SmartForm/types';

import { z } from 'zod';

import type { PickedUser } from './UserPicker';

import { useModal } from '../../modals/hooks/useModal';
import { UserPicker } from './UserPicker';

const CREATE_USER = 'create-user';

const USER_QUICK_LOOK = 'user-quick-look';

const pickedUserSchema = z
  .object({
    id: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    email: z.string().nullish(),
    phone: z.string().nullish(),
  })
  .passthrough() satisfies z.ZodType<PickedUser>;

const toPickedUser = (value: FormFieldProps['value']) => {
  const parsed = pickedUserSchema.safeParse(value);

  return parsed.success ? parsed.data : null;
};

export const LoanMemberPickerField = ({
  value,
  onChange,
  error,
  disabled,
}: FormFieldProps & { disabled?: boolean }) => {
  const { open } = useModal();

  const adoptUser = (result?: { user?: PickedUser | null }) => {
    if (result?.user) onChange(result.user);
  };

  return (
    <UserPicker
      value={toPickedUser(value)}
      onChange={onChange}
      disabled={disabled}
      invalid={!!error}
      onCreateUser={() => void open(CREATE_USER).then(adoptUser)}
      onInspectUser={(userId) => void open(USER_QUICK_LOOK, { userId }).then(adoptUser)}
    />
  );
};
